var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _circle, _circle2, _circle3, _circle4, _rect15, _rect16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 176,
    viewBox: "0 0 298 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 189.862,
    y: 64.5596,
    width: 97.4072,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 218.753,
    y: 130.598,
    width: 40.4488,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 229.485,
    y: 139.679,
    width: 40.4488,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 153.54,
    y: 0.997192,
    width: 40.4488,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 164.271,
    y: 10.0775,
    width: 40.4488,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 156.017,
    y: 75.2908,
    width: 97.4072,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 200.593,
    y: 86.0221,
    width: 97.4072,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33.845,
    y: 81.8947,
    width: 97.4072,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 92.626,
    width: 97.4072,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5762,
    y: 103.357,
    width: 97.4072,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 73.4683,
    y: 41.4459,
    width: 97.4072,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 118.044,
    y: 48.0498,
    width: 97.4072,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 76.77,
    y: 133.075,
    width: 97.4072,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9253,
    y: 143.806,
    width: 97.4072,
    height: 13.2078,
    rx: 4,
    fill: "#E4FCCA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 106.247,
    r: 66.7535,
    fill: "#E4FCCA",
    stroke: "#71BE34",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.086,
    cy: 98.4044,
    r: 9.40582,
    fill: "#E4FCCA",
    stroke: "#83D344"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.4073,
    cy: 24.1108,
    r: 9.40582,
    fill: "#E4FCCA",
    stroke: "#83D344"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.565,
    cy: 113.263,
    r: 9.40582,
    fill: "#E4FCCA",
    stroke: "#83D344"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 122.369,
    y: 105.879,
    width: 31.9066,
    height: 9.5692,
    rx: 4,
    transform: "rotate(37.6569 122.369 105.879)",
    fill: "#71BE34"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 181.295,
    y: 83.4491,
    width: 63.4878,
    height: 9.5692,
    rx: 4,
    transform: "rotate(128.208 181.295 83.4491)",
    fill: "#71BE34"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.07156d1aff5123f0475fffcf0ada5ae9.svg";
export { ForwardRef as ReactComponent };